import { Component } from 'react';
import type { ErrorInfo, ReactNode } from 'react';
import { Button, Result } from 'antd';

interface Props {
  children: ReactNode;
}
interface State {
  error: Error | null;
}

/**
 * 页面级错误边界：单个页面渲染抛错时只替换内容区，侧栏/顶栏仍可用，
 * 避免整个后台白屏。AppLayout 以 pathname 作 key，切页自动复位。
 */
export default class RouteErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('[admin-web] 页面渲染异常', error, info.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <Result
        status="error"
        title="页面出了点问题"
        subTitle="这个页面渲染失败了，其他页面不受影响。可以重试，或换个页面继续。"
        extra={[
          <Button key="retry" type="primary" onClick={() => this.setState({ error: null })}>
            重试
          </Button>,
          <Button key="reload" onClick={() => window.location.reload()}>
            刷新页面
          </Button>,
        ]}
      />
    );
  }
}
